import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import admin           from './modules/admin';
import correction_mode from './modules/correctionMode';
import display         from './modules/display';
import tasks           from './modules/tasks';
import theme           from './modules/theme'

const reducer = combineReducers({
  admin,
  correction_mode,
  display,
  tasks,
  theme,
});

const composeEnhancers = compose;

export const store = createStore(
  reducer,
  composeEnhancers( 
    applyMiddleware(
      thunkMiddleware
  ))
);